import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { BUY_MEMBERSHIP } from "../constants";

@Injectable({
  providedIn: 'root'
})
export class PurchaseRedirectGuard implements CanActivate {
  constructor(private storeService: StorageService, private router: Router) { }
  canActivate(): boolean {
    if (this.storeService?.getMiniEnvConfig()?.purchasePageUrl) {
      if (this.storeService.getMiniEnvConfig().purchasePageUrl.includes(BUY_MEMBERSHIP)) {
        return true
      }
      else{
        // This is the flow for mini env path
        const [url, fragment] = this.storeService.getMiniEnvConfig().purchasePageUrl.split('#');
        this.router.navigate([url], { fragment: fragment });
        return false
      }
    }
    else {
      // Let it pass through the normal flow for non mini env path
      return true
    }
  }
}